module.exports = __webpack_public_path__ + "img/rec-01.d9be4e26.png";